/**
 * Renders the main application component and routes.
 * 
 * @returns {JSX.Element} The main application component.
 */

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './App.css';
import Loader from "./views/Loader";
import Game from "./views/Game";
import Queue from 'promise-queue';


import { useNavigate } from "react-router-dom";
import React from "react";
import { Alert, Box, Stack } from "@mui/material";

function App(props) {
  const navigate = useNavigate();

  //minimum window size: 1366x768
  //we are targeting 1366x768 display size
  //if the browser window is maximized and has a toolbar and a menu bar for the OS
  //we are assuming a usable height of 648px
  const MIN_WIDTH = 1080;
  const MIN_HEIGHT = 648;

  //TODO: determine what data needs to be preloaded and load it here
  //my plate data
  const [data, setData] = React.useState(null);

  //error state

  //variable to track total number of assets to load
  const [loadedState, setLoadedState] = React.useState({ totalAssets: 0, assetsLoaded: 0 });

  const [error, setError] = React.useState(null);

  const [windowToSmall, setWindowToSmall] = React.useState(false);

  //load the game assets
  React.useEffect(() => {

    // Resets any existing errors to null at the start of the effect.
    setError(null);

    // Constructs the URL for the data file based on a prop and an environment variable.
    let dataFileURL = props.resourceURI + '/' + process.env.REACT_APP_DATA_FILE;

    // A Set to keep track of the unique assets that have been loaded.
    let loadedAssetsSet = new Set();

    //if screen is to small for game dont load data
    // if (window.innerWidth < MIN_WIDTH || window.innerHeight < MIN_HEIGHT) {
    //   console.log(`Window is too small to play the game: ${window.innerWidth}x${window.innerHeight}`);
    //   setWindowToSmall(true);
    //   return;
    // }

    // Fetches the data file from the constructed URL.
    console.log(`Fetching data file: ${dataFileURL}`);
    fetch(dataFileURL)
      .then(response => response.json()) // Parses the response as JSON.
      .then(data => {
        // Sets the fetched data into state.
        setData(data);

        // A Set to determine the total number of unique assets.
        let totalAssets = new Set();
        data.sections.forEach(section => {
          section.views.slice(0, 3).forEach(view => {
            // Adds asset URLs to the totalAssets Set to ensure uniqueness.
            if (view.assetURL) {
              totalAssets.add(view.assetURL);
            }
            if (view.voiceoverAudioClipUrl) {
              totalAssets.add(view.voiceoverAudioClipUrl);
            }
          });
        });

        // Updates the loadedState with the count of total unique assets.
        setLoadedState({ totalAssets: totalAssets.size, assetsLoaded: 0 });

        // Create a new queue with a maximum concurrency of 2.
        let q = Queue;
        let queue = new Queue(1, Infinity);

        data.sections.forEach(section => {
          //loop through the first 5 views of the section


          section.views.slice(0, 3).forEach(view => {
            // A function to handle the loading of an asset.
            const handleAssetLoaded = (assetURL) => {
              // Logs the attempt to load an asset.
              console.log(`Loading asset: ${assetURL}`);
              // Checks if the asset has already been handled; if not, it's added to the set and counted.
              if (!loadedAssetsSet.has(assetURL)) {
                loadedAssetsSet.add(assetURL);
                setLoadedState(prevState => ({
                  ...prevState,
                  assetsLoaded: prevState.assetsLoaded + 1
                }));
              }
            };

            // Function to load an image
            const loadImage = (assetURL) => {
              return new Promise((resolve, reject) => {
                let img = new Image();
                img.src = process.env.REACT_APP_PUBLIC_URL + assetURL;
                img.onload = () => {
                  handleAssetLoaded(assetURL);
                  resolve();
                };
                img.onerror = () => {
                  console.error(`Error loading image: ${assetURL}`);
                  handleAssetLoaded(assetURL);
                  resolve();
                };
              });
            };

            // Function to load an audio
            const loadAudio = (audioClipUrl) => {
              return new Promise((resolve, reject) => {
                let audio = new Audio();
                audio.src = process.env.REACT_APP_PUBLIC_URL + audioClipUrl;
                audio.onloadeddata = () => {
                  handleAssetLoaded(audioClipUrl);
                  resolve();
                };
                audio.onerror = () => {
                  console.error(`Error loading audio: ${audioClipUrl}`);
                  handleAssetLoaded(audioClipUrl);
                  resolve();
                };
              });
            };

            // Add tasks to the queue
            if (view.assetURL) {
              queue.add(() => loadImage(view.assetURL));
            }
            if (view.voiceoverAudioClipUrl) {
              queue.add(() => loadAudio(view.voiceoverAudioClipUrl));
            }
          });
        });

      })
      // Catches and handles any errors that occur during the fetching process.
      .catch(error => {
        setError(`There was an error loading the game data file: ${error.message}`);
      });

    // The effect depends on props.resourceURI and will re-run if this value changes.
  }, [props.resourceURI]);





  React.useEffect(() => {
    let progress = 0;
    if (loadedState.totalAssets > 0) {
      progress = (loadedState.assetsLoaded / loadedState.totalAssets) * 100;
    } else if (loadedState.assetsLoaded === loadedState.totalAssets) {
      progress = 100; // When all assets are loaded.
    }
    console.log(`assetsLoaded: ${loadedState.assetsLoaded}, totalAssets: ${loadedState.totalAssets}, progress: ${progress}%`);
  }, [loadedState]);


  return (
    <Box display="flex" justifyContent="center" alignItems="center" style={{ height: '100vh' }}>
      <div className="App">
        {/* MUI Error */}
        {error && <Alert severity="error">{error}</Alert>}
        <Routes>
          {data &&
            <>
              <Route path="/game" element={<Game data={data} navigate={navigate} />} />
            </>
          }

          {/* {windowToSmall && <Route path="/" element={<Alert severity="warning">Please resize your window to at least {MIN_WIDTH}x{MIN_HEIGHT} to play the game. <em>({window.innerWidth}x{window.innerHeight})</em></Alert>} />} */}

          <Route exact path="/" element={<Loader progress={loadedState.totalAssets && loadedState.assetsLoaded ? ((loadedState.assetsLoaded / loadedState.totalAssets) * 100) : 0} navigate={navigate} />} />
        </Routes>
      </div>
    </Box>
  );
}

export default App;
